module.exports = __webpack_public_path__ + "static/img/home-hot6.70f427a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-hot6.png
// module id = GaQ9
// module chunks = 21